export default __webpack_public_path__ + "static/media/ISSO CLASS-9 EXAM PATTERN 2025.ae506ad3.pdf";